module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.2812/img/favicon-dark.png"